import { ApolloClient } from '@apollo/client/core'
import { ApolloClients, provideApolloClient } from '@vue/apollo-composable'
import { boot } from 'quasar/wrappers'
import { getClientOptions } from 'src/apollo'
import auth from 'src/apollo/auth'
import siteInfo from 'src/apollo/queries/siteInfo.gql'
import { loadDevMessages } from '@apollo/client/dev'
import { getConfig } from 'src/configs'
import { initCDA } from 'src/core/hooks/init-cda'
import { openNewMirror } from 'src/common/functions'

const config = getConfig()

function getSiteInfo(store, apolloClient) {
  return apolloClient
    .query({
      query: siteInfo,
    })
    .then(async ({ data }) => {
      if (data.siteInfo.additionalRedirect) {
        location.replace(data.siteInfo.additionalRedirect)
        return
      }

      const { domain, mirrorDomain } = data.siteInfo
      const isWebView = process.env.WEBVIEW === '1'
      const isBot = store.state.system.isBot
      const hasToken = store.getters.getToken
      const isNewDomain = domain !== mirrorDomain && Boolean(mirrorDomain.length)
      const isProduction = process.env.NODE_ENV === 'production' && process.env.ENVIRONMENT === 'production'

      if (isProduction && config.useMirrors && !isBot && !isWebView && hasToken && isNewDomain) {
        await openNewMirror(mirrorDomain, apolloClient)
      }

      store.dispatch('setSiteInfo', data.siteInfo)
      store.dispatch('updateUnderDev', data.siteInfo.underDev)
    })
    .catch(console.error)
}

export default boot(async (ctx) => {
  const { app, store } = ctx
  const options = getClientOptions({ store })
  const apolloClient = new ApolloClient(options)

  const apolloClients = {
    default: apolloClient,
  }

  app.config.globalProperties.$apollo = apolloClient

  provideApolloClient(apolloClient)
  app.provide(ApolloClients, apolloClients)

  if (process.env.NODE_ENV === 'development') {
    loadDevMessages()
  }

  await auth(store, apolloClient)
  await getSiteInfo(store, apolloClient)
  await initCDA(apolloClient, store)
})
